import { BROWSER } from '@/constants';
import { browserAxios } from '@/lib/axios';

import { API_AUTH_RESULT_CODE } from './apiAuth';

/** 1 語句ぶんの辞書エントリ（API の JSON 形式） */
export type VocabEntry = {
  content: string;
  /** 読み方が無い語句では省略できる */
  sounds_like?: string[];
};

/**
 * リクエストパラメータ。
 * vocab のキーはバックエンドの言語コード（`ja` / `en` / `zh-CN` など）。
 *
 * ⚠️ convertObjectToSneakJson は 1 階層しか変換せず値を String 化するため使わない。
 *    スネークケースのキーはここで直接定義する。
 */
export type VocabApiRequest = {
  access_key: string;
  token: string;
  vocab: Record<string, VocabEntry[]>;
};

/** 辞書保存 API 専用タイムアウト（ms）。会話開始を止めない API なので共通値より短くする。 */
export const VOCAB_API_TIMEOUT = 5000;

/**
 * 結果コード。
 * バックエンドは他の API と同じく HTTP 200 ＋ result_code で失敗を返す。
 * 呼び出し元では現在使用していない（fail-open のため）。
 */
export const VOCAB_API_RESULT_CODE = {
  ...({
    // 成功
    OK: 'OK',
    // 入力パラメータエラー
    WARN_INPUT_PARAM: 'WARN_INPUT_PARAM',
    // キー不正
    WARN_INVALID_KEY: 'WARN_INVALID_KEY',
    // 言語コード不正
    WARN_INVALID_LANG: 'WARN_INVALID_LANG',
    // 保存失敗
    ERR_SAVE_FAILED: 'ERR_SAVE_FAILED',
    // 不明なエラー
    ERR_UNKNOWN: 'ERR_UNKNOWN',
  } as const),
  ...API_AUTH_RESULT_CODE,
} as const;
export type VocabApiResultCode =
  (typeof VOCAB_API_RESULT_CODE)[keyof typeof VOCAB_API_RESULT_CODE];

export type VocabApiResponse = {
  resultCode: VocabApiResultCode;
};

/**
 * 辞書保存 API リクエスト
 */
export const vocabApi = (request: VocabApiRequest): Promise<VocabApiResponse> =>
  browserAxios
    .post<VocabApiResponse>(BROWSER.API_URL.VOCAB, request, {
      headers: { 'Content-Type': 'application/json' },
      timeout: VOCAB_API_TIMEOUT,
    })
    .then((res) => res.data);
